<template>
  <section :class="['outer', 'testimonials', `section-styling-${testimonialStyle}`]" v-if="hasContent(context.item.modultestimonialsueberschrift)">
    <div class="container">
      <h2 class="section-title testimonials__title">
        <span class="headline">{{ testimonialTitle }}</span>
      </h2>

      <div class="grid-auto grid-auto-3c">
        <!-- Schleife über Testimonials -->
        <blockquote
          v-for="i in testimonialItems"
          :key="i"
          class="item-vertical item-vertical--testimonial"
        >
          <figure class="item-vertical__figure item-vertical--testimonial__figure">
            <img
              :src="getField(`modultestimonialsbild${i}`).url"
              :alt="getField(`modultestimonialsbild${i}`).alt"
              class="item-vertical__img item-vertical--testimonial__img"
            />
            <figcaption class="item-vertical__caption item-vertical--testimonial__caption">
              {{ getField(`modultestimonialsbild${i}`).caption }}
            </figcaption>
          </figure>
          <h3 class="item-vertical__title item-vertical--testimonial__title">
            <span class="headline">{{ getField(`modultestimonialsuntertitel${i}`) }}</span>
          </h3>
          <div v-html="getField(`modultestimonialstext${i}`)"></div>
        </blockquote>
      </div>

      <div class="center" v-if="button.url">
        <a :href="button.url" :target="button.target" class="button button--cat1 button--large">
          {{ button.text }}
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "TestimonialsComponent",
  props: {
    context: {
      type: Object,
      required: true,
    },
  },
  computed: {
    testimonialTitle() {
      return this.context.item?.modultestimonialsueberschrift || "";
    },
    testimonialStyle() {
      return this.context.item?.modultestimonialsstyle || "0";
    },
    button() {
      return this.context.item?.modultestimonialsbutton || {};
    },
    testimonialItems() {
      return Array.from({ length: 6 }, (_, index) => index + 1).filter(
        (i) => this.getField(`modultestimonialsuntertitel${i}`)
      );
    },
  },
  methods: {
    getField(field) {
      const fullPath = `${field}`;
      return this.context.item[fullPath] || '';
    },

    hasContent(fieldContent) {
      return fieldContent && fieldContent.trim().length > 0;
    },  
  },
};
</script>